<template>
  <div :class="['vv-progress-circle', this.classIsMobile]">
    <div v-if="!isLocked" :class="['vv-progress-circle-div', this.classIsLesson, this.classIsComplete]">

      <svg xmlns="http://www.w3.org/2000/svg" height="200" width="200" viewBox="0 0 200 200"
      v-if="!isRouteDetail && ((this.changeImgSuccess && this.percentage != '100') || !this.changeImgSuccess)">
        <path
          stroke="#f1f1f1"
          d="M 100, 100 m 0,-75 a 75,75 0 0,1 0,150 a 75,75 0 0,1 0,-150"
          fill="none"
        />
        <path
          class="meter"
          d="M 100, 100 m 0,-75 a 75,75 0 0,1 0,150 a 75,75 0 0,1 0,-150"
          fill="none"
          :stroke="color || '#51da7e'"
          stroke-dasharray="471.305419921875"
          :stroke-dashoffset="offset"
        />
        <text
          x="50%"
          y="50%"
          dominant-baseline="middle"
          text-anchor="middle"
          class="percentage"
          :style="{ fill: this.color }"
        >
          {{ roundedPercentage }}%
        </text>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" height="200" width="200" viewBox="0 0 200 200"
      v-if="isRouteDetail && ((this.changeImgSuccess && this.percentage != '100') || !this.changeImgSuccess)">
        <path
          stroke="#f1f1f1"
          d="M 100, 100 m 0,-75 a 75,75 0 0,1 0,150 a 75,75 0 0,1 0,-150"
          fill="none"
        />
        <path
          class="meter"
          d="M 100, 100 m 0,-75 a 75,75 0 0,1 0,150 a 75,75 0 0,1 0,-150"
          fill="none"
          :stroke="color || '#51da7e'"
          stroke-dasharray="471.305419921875"
          :stroke-dashoffset="offset"
        />
        <text
          x="50%"
          y="50%"
          dominant-baseline="middle"
          text-anchor="middle"
          class="percentage"
          :style="{ fill: this.color }"
        >
          {{ roundedPercentage }}%
        </text>
      </svg>
      <img :class="['vv-progress-circle-image', this.classRouteDetail, this.classIsLesson]" v-if="this.changeImgSuccess && this.percentage == '100'" :src="this.tileImage" />
    </div>
    <div v-else class="vv-progress-circle-div locked" :style="{ 'backgroundImage': 'linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(' + this.tileImage + ')' }">
      <img :class="['vv-progress-circle-image-locked']" :src="this.cadenasImage" />
    </div>
  </div>
</template>

<script>
// M 100, 100 m 0,-75 a 75,75 0 0,1 0,150 a 75,75 0 0,1 0,-150
// move to 100,100 absolute (middle of the circle)
// move to 0, -75 relative => goes on top of the cirlce
// draw an arc relative (from the top) to the same coordinate + 150 on y (0, 150)
// draw an arc relative (from the bottom, where we stopped on the last arc)
// to the same coordinate -150 on y (0, -150)

// 471.305419921875 is the path length and we move the offset to handle the progression
// we can obtain the path length by query selecting it and using:
// path.getTotalLength()

export default {
  name: 'vv-progress-circle',
  props: {
    percentage: Number,
    color: String,
    image: String,
    changeImgSuccess: Boolean,
    isLocked: Boolean,
    isRouteDetail: Boolean,
    isLesson: Boolean,
    isComplete: Boolean,
    isMobile: Boolean
  },
  computed: {
    roundedPercentage() {
      return Math.ceil(this.percentage)
    },
    offset() {
      return 471.305419921875 * ((100 - this.percentage) / 100)
    },
    tileImage() {
      return this.image
    },
    cadenasImage() {
      return require('@/assets/Cadenas@2x.png')
    },
    classRouteDetail() {
      return this.isRouteDetail ? 'progression-detail' : ''
    },
    classIsLesson() {
      return this.isLesson ? 'progression-lesson' : ''
    },
    classIsComplete() {
      return this.isComplete ? 'lesson-complete' : ''
    },
    classIsMobile() {
      return this.isMobile ? 'progress-circle-mobile' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';
@import '@/assets/styles/responsive.scss';

.vv-progress-circle {
  display: inline-block;

  svg path {
    fill: none;
    stroke-width: 10px;
    stroke-miterlimit: round;
    transition: stroke-dashoffset 850ms ease-in-out;
  }

  .percentage {
    font-size: 36px;
    font-weight: 500;
    fill: $secondary;
  }
}

.vv-progress-circle-image {
  margin: 10px 0px 10px 0px;

  &:not(.progression-lesson) {
    width: 140px;
    height: 140px;
    border-radius: 50%;
    border: 10px solid #D00E4A;
    margin-top: 20px;
  }

  &.progression-detail {
    width: 140px;
    height: 140px;
    border-width: 10px;
    margin-top: 20px;
    margin-right: 20px;
  }

  &.locked {
    position: relative;
    border: 10px solid #838383;
  }
}

.vv-progress-circle-div {
    width: 200px;
    height: 200px;
    justify-content: center;
    display: flex;

  &.locked {
    width: 140px;
    height:140px;
    border-radius: 50%;
    border: 10px solid #838383;
    background-size: contain;
    // margin-top: 20px;
    margin-right: 20px;
    margin-top: 20px;
    background-position: center;
    background-size: cover;
  }
  &.progression-lesson {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 6px solid #D00E4A;
    margin-top: 15px;

    &:not(.lesson-complete) {
      border-color: #838383;
    }

    .vv-progress-circle-image {
      width: 70%;
      height: 70%;
      // margin-left: 20px;
      // margin-top: 20px;
    }

    @include for-size(tablet-portrait-down) {
      width: 50px;
      height: 50px;

      .vv-progress-circle-image {
        width: 70%;
        height: 70%;
        // margin-left: 10px;
        margin-top: 7px;
      }
    }
  }

  
}

.vv-progress-circle-image-locked
{
  position: relative;
  width: 100%;
  height: 100%;
  padding-right: 7px;
  padding-left: 7px;
  z-index: 1;
}

.progress-circle-mobile {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .vv-progress-circle-div {
    width: 100%;
    height: 100%;

    img {
      width: 100px;
      height: 100px;
      border-width: 8px;
      margin-right: 0px;
    }

    svg {
      width: 148px !important;
      height: 148px !important;
      padding-top: 4px !important;
    }

    &.locked {
      width: 100px;
      height: 100px;
      margin-right: 0;
      border-width: 8px;
      background-position: center;
      background-size: cover;

      .vv-progress-circle-image-locked {
        width: 100%;
        height: 100%;
        padding-right: 6px;
      }
    }
  }
}
</style>
